// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"rQ-z","categoryName":"sQ-z","categoryNameSearchHeader":"tQ-z","categoryContent":"uQ-z","bottomAligned":"vQ-z","image":"wQ-z","imageNoBackground":"xQ-z"};